import * as Sentry from "@sentry/react-native";
import * as SecureStore from "expo-secure-store";

type SecureStoreAccessOptions = {
  throwOnError?: boolean;
};

/**
 *
 * Wrapper for expo secure store access -- with error handling
 */
export const getExpoSecureStoreItemAsync = async (
  key: string,
  options: SecureStoreAccessOptions = {}
) => {
  try {
    return await SecureStore.getItemAsync(key, {
      keychainAccessible: SecureStore.AFTER_FIRST_UNLOCK,
    });
  } catch (e) {
    Sentry.captureException(e);
    if (options.throwOnError) {
      throw e;
    }
    return null;
  }
};

/**
 *
 * Wrapper for expo secure store access -- with error handling
 */
export const setExpoSecureStoreItemAsync = async (
  key: string,
  value: string,
  options: SecureStoreAccessOptions = {}
) => {
  try {
    return await SecureStore.setItemAsync(key, value, {
      keychainAccessible: SecureStore.AFTER_FIRST_UNLOCK,
    });
  } catch (e) {
    Sentry.captureException(e);
    if (options.throwOnError) {
      throw e;
    }
    return null;
  }
};

/**
 *
 * Wrapper for expo secure store access -- with error handling
 */
export const deleteExpoSecureStoreItemAsync = async (
  key: string,
  options: SecureStoreAccessOptions = {}
) => {
  try {
    return await SecureStore.deleteItemAsync(key, {
      keychainAccessible: SecureStore.AFTER_FIRST_UNLOCK,
    });
  } catch (e) {
    Sentry.captureException(e);
    if (options.throwOnError) {
      throw e;
    }
    return null;
  }
};
